import {React} from 'common'
import SearchIcon from '@mui/icons-material/Search'
import {Colors} from 'appearance'
import {CircularProgress, InputAdornment, TextField} from '@mui/material'
import useSearchBar from 'logic/Control/useSearchBar'
import styled from 'styled-components'

const SearchBar = ({isMobile, isLoading}) => {
    const {searchTerm, handleSearchChange} = useSearchBar()

    return (
        <SearchStyledContainer isMobile={isMobile}>
            <TextField
                value={searchTerm}
                autoFocus
                fullWidth
                rows={1}
                variant="standard"
                onChange={handleSearchChange}
                InputProps={{
                    disableUnderline: true,
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            {!!isLoading && (
                                <CircularProgress size={16} sx={{mx: 1}} />
                            )}
                        </InputAdornment>
                    ),
                }}
            />
        </SearchStyledContainer>
    )
}

export default SearchBar

const SearchStyledContainer = styled.div`
    background-color: ${Colors.APP_WHITE};
    border-radius: 6px;
    width: ${(isMobile) => (isMobile ? '100%' : '300px')};
    position: relative;
`
